import { Icon } from '@chakra-ui/react';

const PCGoogleMapIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M2.15,22.65c1.48-0.97,2.88-0.98,4.32-0.03c0.02-0.13,0.05-0.23,0.05-0.34c0-3.82,0.01-7.65,0-11.47
		c0-1.19-0.95-2.09-2.17-2.1c-1.25-0.01-2.19,0.9-2.2,2.12c-0.01,0.86-0.01,1.73,0,2.59c0,0.37-0.12,0.66-0.56,0.66
		c-0.4-0.01-0.54-0.28-0.53-0.63c0.01-0.95-0.02-1.9,0.01-2.84C1.11,9.02,2.58,7.7,4.3,7.69c1.76-0.01,3.25,1.28,3.31,2.89
		c0.01,0.37,0,0.74,0,1.14c1.3,0,2.57,0,3.92,0c-0.1-0.17-0.19-0.32-0.27-0.48C10.75,10.17,10.11,9.13,9.76,8
		c-0.73-2.33,0.96-4.92,3.59-5.74c3.55-1.1,7.27,1.43,7.17,4.9c-0.03,1.16-0.61,2.18-1.15,3.19c-0.24,0.45-0.51,0.89-0.78,1.37
		c1.32,0,2.59,0,3.92,0c0-0.32,0-0.64,0-0.95c0.01-1.73,1.45-3.08,3.27-3.08c1.82,0,3.29,1.35,3.29,3.06c0.01,4.72,0,9.44,0,14.16
		c0,1.74-1.44,3.08-3.33,3.08c-7.07,0-14.14,0-21.21,0c-1.98,0-3.45-1.37-3.46-3.2c0-2.33,0-4.67,0-7c0-0.37,0.13-0.66,0.57-0.65
		c0.4,0.01,0.54,0.29,0.52,0.64c-0.01,0.15,0,0.3,0,0.46C2.15,19.68,2.15,21.12,2.15,22.65z M27.97,22.63c0-0.19,0-0.29,0-0.39
		c0-3.81,0-7.61,0-11.42c0-1.22-0.95-2.13-2.2-2.12c-1.25,0.01-2.17,0.91-2.17,2.15c0,3.79,0,7.58,0,11.36
		c0,0.12,0.03,0.24,0.04,0.4C25.08,21.67,26.48,21.67,27.97,22.63z M7.62,12.62c0,0.81,0.02,1.4-0.01,1.99
		c-0.01,0.33,0.09,0.56,0.36,0.79c2.05,1.8,4.09,3.61,6.14,5.42c0.55,0.49,0.55,0.67,0,1.15c-1.72,1.52-3.43,3.03-5.15,4.54
		c-0.14,0.12-0.32,0.21-0.48,0.31c0.04,0.05,0.07,0.11,0.11,0.16c0.83,0,1.66,0.03,2.49-0.01c0.27-0.01,0.6-0.13,0.8-0.31
		c1.58-1.43,3.2-2.82,4.66-4.35c1.06-1.11,2.2-1.65,3.78-1.44c0.71,0.09,1.44,0.02,2.16,0.02c0-0.71,0-1.35,0-2.03
		c-0.22,0-0.42,0-0.61,0c-2.04,0-4.08-0.01-6.12,0.01c-0.5,0.01-0.85-0.14-1.2-0.46c-1.99-1.79-3.99-3.56-6.01-5.32
		C8.32,12.9,8.01,12.81,7.62,12.62z M22.5,21.9c-1.2,0-2.33-0.02-3.45,0.01c-0.27,0.01-0.6,0.13-0.8,0.31
		c-1.59,1.44-3.16,2.91-4.73,4.37c-0.11,0.1-0.2,0.21-0.33,0.35c0.12,0.02,0.17,0.04,0.22,0.04c4.14,0,8.27,0.01,12.41,0
		c1.2,0,2.14-0.92,2.15-2.02c0.01-1.1-0.89-1.98-2.06-2.04c-1.19-0.05-2.19,0.74-2.3,1.87c-0.04,0.36-0.13,0.67-0.57,0.65
		c-0.44-0.01-0.53-0.32-0.53-0.69C22.51,23.83,22.5,22.9,22.5,21.9z M15.06,14.86c1.64-2.26,3.3-4.41,4.22-6.95
		c0.1-0.27,0.14-0.56,0.14-0.85c0.04-2.66-2.82-4.64-5.58-3.88c-2.35,0.64-3.71,2.88-2.94,4.96C11.84,10.59,13.46,12.67,15.06,14.86
		z M7.62,16.49c0,0.32,0,0.5,0,0.68c0,2.5,0,5.01,0,7.51c0,0.37-0.03,0.73-0.51,0.76c-0.47,0.03-0.56-0.3-0.6-0.68
		c-0.1-1.02-0.99-1.79-2.05-1.84c-1.2-0.06-2.25,0.82-2.31,1.92c-0.06,1.12,0.94,2.09,2.22,2.14c0.67,0.03,1.35,0.04,2.02-0.01
		c0.28-0.02,0.61-0.13,0.8-0.3c1.86-1.62,3.7-3.26,5.55-4.89c0.13-0.11,0.3-0.19,0.5-0.32C11.33,19.77,9.53,18.18,7.62,16.49z
		 M22.48,12.77c-1.41,0-2.77,0.01-4.13-0.01c-0.36-0.01-0.55,0.12-0.73,0.39c-0.63,0.89-1.27,1.77-1.93,2.64
		c-0.46,0.6-0.79,0.6-1.25-0.01c-0.67-0.88-1.31-1.79-1.97-2.67c-0.1-0.13-0.24-0.31-0.37-0.31c-0.73-0.03-1.47-0.01-2.32-0.01
		c1.92,1.7,3.73,3.32,5.56,4.91c0.13,0.12,0.39,0.16,0.59,0.16c1.62,0.01,3.24,0.01,4.86,0.01c0.56,0,1.12,0,1.7,0
		C22.48,16.14,22.48,14.49,22.48,12.77z"/>
			<path class="st0" d="M15.06,9.62c-1.51,0-2.74-1.15-2.73-2.55c0.01-1.4,1.25-2.53,2.76-2.52c1.48,0.01,2.7,1.15,2.7,2.53
		C17.8,8.47,16.57,9.62,15.06,9.62z M15.08,5.56c-0.89-0.01-1.64,0.67-1.66,1.5c-0.01,0.83,0.71,1.53,1.6,1.55
		c0.91,0.02,1.68-0.68,1.68-1.52C16.7,6.26,15.96,5.56,15.08,5.56z"/>
		</g>

	</Icon>
);

export default PCGoogleMapIcon;
